import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BannersEnum } from '../enums/banners.enum';
import { RoutesUtil } from '../util/RoutesUtil';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    constructor(private readonly http: HttpClient, private readonly routesUtil: RoutesUtil,
    ) { }

    dismissBanner(banner: BannersEnum): Observable<BannersEnum[]> {
        const url = this.routesUtil.dismissBanner();
        return this.http.patch<BannersEnum[]>(url, {
            banner,
        });
    }

    updateLastSeenReleaseId(releaseId: string): Observable<string> {
        const url = this.routesUtil.updateLastSeenReleaseId();
        return this.http.patch<string>(url,
            { lastSeenReleaseId: releaseId },
        );
    }
}
